import axios from '../plugins/axios';

const API_URL = '/admin/course-reservations';

export default {
  async getReservations(filters = {}) {
    try {
      // Always include the course relationship
      let url = `${API_URL}?_with_[course]`;
      
      // Add query parameters for filtering if needed
      if (Object.keys(filters).length > 0) {
        const queryParams = [];
        
        for (const key in filters) {
          queryParams.push(`${key}=${encodeURIComponent(filters[key])}`);
        }
        
        url += `&${queryParams.join('&')}`;
      }
      
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching course reservations:', error);
      throw error;
    }
  },
  
  async createReservation(data) {
    try {
      // Ensure number_of_people is a number
      if (data.number_of_people) {
        data.number_of_people = parseInt(data.number_of_people);
      }
      
      // Ensure total_price and discount are numbers
      if (data.total_price) {
        data.total_price = parseFloat(data.total_price);
      }
      
      if (data.discount) {
        data.discount = parseFloat(data.discount);
      }
      
      const response = await axios.post(API_URL, data);
      return response.data;
    } catch (error) {
      console.error('Error creating course reservation:', error);
      throw error;
    }
  },
  
  async updateReservation(id, data) {
    try {
      // Ensure number_of_people is a number
      if (data.number_of_people) {
        data.number_of_people = parseInt(data.number_of_people);
      }
      
      // Ensure total_price and discount are numbers
      if (data.total_price) {
        data.total_price = parseFloat(data.total_price);
      }
      
      if (data.discount) {
        data.discount = parseFloat(data.discount);
      }
      
      const response = await axios.put(`${API_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating course reservation:', error);
      throw error;
    }
  },
  
  async deleteReservation(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting course reservation:', error);
      throw error;
    }
  },
  
  async getReservationById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching course reservation:', error);
      throw error;
    }
  }
}; 